export default "__VITE_ASSET__DFY63ACm__"